<template>
  <p-edit v-if="$hasPermission('users.read')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import EditTeam from './../components/users/EditTeam.vue';

export default {
  components: {
    'p-edit': EditTeam,
    'p-not-found': NotFound
  }
};
</script>
